import { Component, OnInit,ViewChild } from '@angular/core';
import { BaseCase } from '../../../basecase';
import { CommonService } from 'src/service/common.service';
import { NativeService } from '../../../../service/native.service';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseModal } from 'src/model';
import { WebParameterContext } from '../../../../model/common';
import { GridBaseCase } from '../../grid/grid.base.case';
declare var app;
@Component({
  selector: 'app-a2-order-withoutcode',
  templateUrl: './a2-order-withoutcode.component.html',
  styleUrls: ['./a2-order-withoutcode.component.scss']
})
export class A2OrderWithoutcodeComponent   extends GridBaseCase{
  Remark: string = "";//消费者退货备注
  listArr:Array<any> = []; // 拿到的参数
  productDataList :Array<any> = []; // 产品列表
  giftDataList:Array<any> = []; // 礼品列表
  constructor(
    public baseService: BaseCase,
    private com: CommonService,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    public base: BaseModal,
    public native: NativeService
  ) { 
    super();
    this.baseService.FixedSubmitBtn.configName = "A2orderWithoutCode";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "提交";
    this.baseService.FixedSubmitBtn.isSubmitData=true;
    this.baseService.FixedSubmitBtn.type = 1;
    activaRouter.queryParams.subscribe(queryParams => {
    this.listArr = JSON.parse(queryParams.listArr);
    this.productDataList =this.listArr["ProductData"]; 
    this.giftDataList = this.listArr["GiftData"];
    console.log(this.productDataList);
    console.log(this.giftDataList); 
  });

  }

  ngOnInit() {
  }
 //备注输入
 RemarkInput(e) {
  let that = this;
  if (e && e.target.value) {
    if (e.target.value.length > 300) {
      e.target.value = e.target.value.substr(0, 300);
      that.Remark = e.target.value;
    }
  }
}
/**
 * 
 * @param event 
 * @param item 
 * 产品数量
 */

ChangeNumstoreproduc(event,item){
      let that = this;
      setTimeout(() => {
        if (event.target.value) {
          let numvalue: any = this.com.GetNumber(event.target.value);
          if (numvalue) {
            if(numvalue>item.Num){
                item.newNum=item.Num;
               event.target.value =item.Num;
            }else{
              item.newNum= numvalue;
            event.target.value = numvalue;
            }
            
          } else {
            item.newNum= 0;
            event.target.value = 0;
          }
        } else {
          event.target.value = null;
          item.newNum= 0;
        }
      }, 400);
}
/**
 * 
 * @param 赠品输入数量
 * @param item 
 */
ChangeNumstore(event,item){
      let that = this;
      // debugger;
      setTimeout(() => {
        if (event.target.value) {
          let numvalue: any = this.com.GetNumber(event.target.value);
          if (numvalue) {
            if(numvalue>item.a_Num){
                item.Num=item.a_Num;
               event.target.value =item.a_Num;
            }else{
              item.Num= numvalue;
            event.target.value = numvalue;
            }
            
          } else {
            item.Num= 0;
            event.target.value = 0;
          }
        } else {
          event.target.value = null;
          item.Num= 0;
        }
      }, 400);
  console.log(item.Num,"&&&&&");
}
EventClick(){
  console.log("提交");
  const that =this;
  console.log(this.giftDataList,"赠品名称");
  console.log(this.productDataList,"产品名称");
  console.log(that.productDataList.length);
  debugger;
   //#region  过滤产品数量为零或者空的数据
   let _tempArray:Array<any> = new Array<any>();
   _tempArray=that.productDataList.filter(itp=> itp.newNum );
   //#endregion
 
 //#region 过滤礼品数量为空或者空的数据
   let _gifArry:Array<any> = new Array<any>();
   _gifArry = that.giftDataList.filter(gif=> gif.Num );
 // #endregion

   let giftArray:Array<any> = [];
   _gifArry.forEach(items=>{
       giftArray.push({"FK_TBGift_ID":items.a_FK_TBGift_ID,"Order_ID":items.a_Order_ID,"GiftName":items.b_Name,"Num":items.Num });
   });
   
   let productDataList = [];
   _tempArray.forEach(it=>{
     let newproduct:any = {};
           newproduct["Code"] = it["ProductInfoCode"];
           newproduct["CodeIDS"] = [];
           newproduct["CodeIDS"].push({ CodeID: it["TankBarcode"], PurchaseRecordID: it["PurchaseID"], Count: it["newNum"]  });
           productDataList.push(newproduct);
   });
   console.log(productDataList,"拼接的字符");
   console.log(giftArray);
   if(productDataList.length<=0  && giftArray.length<=0){
     that.msg.Alert("请选择退货的产品");
     return;
   }
// return;
  let paramBody = {};
  let IsNotBarcode={
    "IsNotBarcode":1
  }
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "ProductReturn";
  body.OpType = "EDITE";
  body.ConfigType = "form";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 0;
  body.SpecialParameter = JSON.stringify(IsNotBarcode);
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  paramBody["Remark"] = that.Remark || "";
  paramBody["Products"] = productDataList;
  paramBody["Gifts"] = giftArray;
  console.log( paramBody);
  body.RequestBody = JSON.stringify(paramBody);
  
  // return;
  that.msg.Confirm("确认提交吗？", "取消", "确定", "", false).then(res => {
    if (res) {
      that.msg.Loading("请求中，请稍后...").then(load=>{
        that.http.post(app.DEFAULTURL, body).then(data => {
          load.dismiss();
          that.baseService.FixedSubmitBtn.isSubmitData = true;
          /****判断是否第一页end****/
          if (data.ResponseMessage.Success) {
            console.log(data);
            that.msg.Alert("提交成功").then(res=>{
               if(res){
                that.baseService.ListData = new Array<any>();
                that.baseService.arrayData = new Array<any>();
                that.com.goBack();
               }
            });
          } else {
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }).catch(error => {
          load.dismiss();
          that.baseService.FixedSubmitBtn.isSubmitData = true;
          console.log(error);
        });
        load.present();
      });
    }
  })


  
}

}
